import {useEffect} from 'react';
import { App } from '@capacitor/app';
import SiteAuth from "./SiteAuth";
import UrlParamsService from "./UrlParamsService";
import GeoService from "./GeoService";
import { MapService } from "./MapService";
import AppService from "./AppService";

const AppUrlListener = (): null => {
    // dejo comentado este estado porque me es cómodo recuperarlo para cuando necesito debugear en app firmada
    // const [mensaje, setMensaje] = useState('logs:');
    useEffect(() => {
        App.addListener('appUrlOpen', async (event) => {
            const params = (new URL(event.url)).searchParams;
            const hasMapParams = params.get('type') || params.get('id') ||
                (params.get('lat') && params.get('lon'));

            // Deep link con params del mapa: cancelar de forma SÍNCRONA (antes de
            // cualquier await) el rearmado de geolocalización, para ganar la
            // carrera contra geolocateAppActiveHandler, que la reactiva a
            // ACTIVE_LOCK cuando la app vuelve a primer plano (evento
            // appStateChange, posterior a appUrlOpen en el ciclo de Android).
            // Así, al mover el mapa después, el control cae a BACKGROUND solo,
            // igual que al seleccionar una localidad.
            if (hasMapParams) {
                MapService.suppressGeolocateRestore();
            }

            // Handle authentication callbacks. Waits for the authorization data
            // (joining the startup authentication when the app was opened by
            // this very link), so the map params below are applied with a token
            // and the feature card does not fail silently.
            const authorized = await SiteAuth.ensureAuthentication();
            if (authorized || params.get('state')) {
                SiteAuth.handleUrlEvent(event);
            }

            // Deep link con params del mapa recibido con la app ya abierta:
            // cerrar todo lo que hubiera abierto (modal, página, menú, card) y
            // re-leer los params y aplicarlos al mapa (fly + highlight).
            if (hasMapParams) {
                if (AppService.appcomponent) AppService.appcomponent.closeAllOverlays();
                UrlParamsService.applyUrl(event.url);
                GeoService.resetUrlParamsCache();
                if (MapService.mapComponent) MapService.mapComponent.goToUrlParams();
            }
        });
    }, []);

    return null;
    /* <p>
        {mensaje}
    </p>; */
};

export default AppUrlListener;
